import { createActions } from 'reduxsauce'
 
export const { Types, Creators } = createActions({
  modifyPagination: ['obj'],
  reset: null

}, {});
